import { Typography } from '@mui/material'

import { styles } from '../InfoPopper.styles'

export type ClosingTextProps = {
	text: string
}

export default function ClosingText({ text }: ClosingTextProps) {
	return (
		<Typography variant="body1" sx={styles.closingText}>
			{text}
		</Typography>
	)
}
